module.exports = __webpack_public_path__ + "img/4.c7442177.png";